import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/value_slider.svg
 */
const IconValueSlider: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.856 12.347a.49.49 0 00.107-.534.498.498 0 00-.107-.16L19.513 7.31v3.567a.493.493 0 01-.491.486H4.978a.49.49 0 01-.49-.486V7.31L.143 11.653a.492.492 0 000 .694l4.343 4.343v-3.583a.491.491 0 01.491-.49h14.044a.495.495 0 01.49.49v3.563l4.344-4.323z"
      fill="currentColor"
    />
    <path
      d="M11.536 9.793v4.41c0 .21.17.382.382.382h.51a.382.382 0 00.383-.382v-4.41a.382.382 0 00-.383-.382h-.51a.382.382 0 00-.382.382z"
      fill="currentColor"
    />
  </svg>
);

export default IconValueSlider;
